// extracted by mini-css-extract-plugin
export default {"animations":"HololiveAnimation_animations","canvas":"HololiveAnimation_canvas"};